<div class="lock-listing">
  <ng-container>
    <div class="scroll-container">
      <div class="overflow-y">
        <ng-container
          *ngFor="
            let device of deviceList | sortBy : 'deviceName' : 'asc';
            let i = index
          "
        >
          <ng-container
            *ngIf="device.activationState !== CONSTANTS.PENDING_DEACTIVATION"
          >
            <div class="mb-2 px-1">
              <div
                class="row-padding d-flex align-items-start pt-3 pb-3"
                [ngClass]="{
                  'device-list':
                    getBatteryError(
                      device?.activationState,
                      device?.batteryPercentage
                    ) !== ''
                }"
              >
                <div class="lock-icon col-1">
                  <img
                    alt="User Icon"
                    [src]="
                      '/assets/svg/' +
                      getLockImg(
                        device.activationState,
                        device?.batteryPercentage,
                        device?.deviceStatus
                      )
                    "
                    class="height-40 width-40"
                  />
                </div>
                <div class="d-flex flex-column col-7 justify-content-center">
                  <div class="tab-heading">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ device?.deviceName }}
                    </app-with-tooltip>
                  </div>
                  <div class="tab-date">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{
                        device?.updatedTime
                          | parsedDateTime : "MMM d, yyyy h:mma"
                      }}
                    </app-with-tooltip>
                  </div>
                </div>
                <div class="filter-icon-margin pr-3 pt-2 pointer-cursor col-3">
                  <div class="d-flex flex-row justify-content-end">
                    <ng-container
                      *ngIf="
                        device?.activationState !== CONSTANTS.PENDING_ACTIVATION
                      "
                    >
                      <span
                        class="ml-auto pl-2 battery-container"
                        *ngIf="
                          device?.batteryPercentage >= 0 &&
                          device?.batteryPercentage !== null
                        "
                      >
                        {{ device?.batteryPercentage + "%" }}
                      </span>
                      <img
                        class="ml-1 pr-2"
                        [src]="
                          '/assets/svg/' +
                          getBatteryImg(device?.batteryPercentage)
                        "
                      />
                    </ng-container>
                    <img
                      class="ml-2"
                      [ngClass]="{
                        'ml-2':
                          device?.activationState !==
                          CONSTANTS.PENDING_ACTIVATION,
                        'ml-auto':
                          device?.activationState ===
                          CONSTANTS.PENDING_ACTIVATION
                      }"
                      src="assets/svg/ico-menu-button.svg"
                      (click)="
                        navigateToDeviceInfo(
                          device?.deviceId,
                          device?.deviceName,
                          device?.batteryPercentage,
                          device?.activationState,
                          CONSTANTS.UNIT
                        )
                      "
                    />
                  </div>
                </div>
              </div>
              <ng-container
                *ngIf="device?.activationState === CONSTANTS.PENDING_ACTIVATION"
              >
                <div class="px-3 pt-2 pb-2 d-flex floor-installation">
                  <div class="pr-3 pl-1 align-self-center">
                    <img
                      alt="User Icon"
                      src="assets/svg/ico-lock-warning-outline-white.svg"
                    />
                  </div>
                  <div>
                    {{
                      getBatteryError(
                        device?.activationState,
                        device?.batteryPercentage
                      )
                    }}
                  </div>
                </div>
              </ng-container>
              <ng-container
                *ngIf="
                  getBatteryPercentage(device?.batteryPercentage) <=
                  CONSTANTS.BATTERY_ALARAM_PERCENTAGE
                "
              >
                <div class="px-3 pt-2 pb-2 d-flex floor-installation">
                  <div class="pr-3 pl-1 align-self-center">
                    <img
                      alt="User Icon"
                      src="assets/svg/ico-lock-warning-outline-white.svg"
                    />
                  </div>
                  <div>
                    {{
                      getBatteryError(
                        device?.activationState,
                        device?.batteryPercentage
                      )
                    }}
                    <a
                      class="see-detail pointer-cursor"
                      (click)="onSeeDetails(device?.deviceName)"
                    >
                      {{ 'SEE_DETAILS' | translate }}
                    </a>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container
            *ngIf="device.activationState === CONSTANTS.PENDING_DEACTIVATION"
          >
            <div class="mb-2 px-1">
              <div
                class="row-padding d-flex align-items-start pt-3 pb-3"
                [ngClass]="{
                  'device-list':
                    getBatteryError(
                      device?.activationState,
                      device?.batteryPercentage
                    ) !== ''
                }"
              >
                <div class="lock-icon-center col-1">
                  <img
                    alt="User Icon"
                    [src]="
                      '/assets/svg/' +
                      getLockImg(
                        device.activationState,
                        device?.batteryPercentage,
                        device?.deviceStatus
                      )
                    "
                    class="height-40 width-40"
                  />
                </div>
                <div class="d-flex flex-column col-7 justify-content-center">
                  <div class="tab-heading">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ device?.deviceName }}
                    </app-with-tooltip>
                  </div>
                  <div class="tab-date">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{
                        device?.updatedTime
                          | parsedDateTime : "MMM d, yyyy h:mma"
                      }}
                    </app-with-tooltip>
                  </div>
                </div>
                <div class="filter-icon-margin pt-2 pointer-cursor col-3">
                  <div class="d-flex flex-row justify-content-end">
                    <img
                      class="ml-2"
                      src="assets/svg/ico-menu-button.svg"
                      (click)="
                        navigateToDeviceInfo(
                          device?.deviceId,
                          device?.deviceName,
                          device?.batteryPercentage,
                          device?.activationState,
                          CONSTANTS.UNIT
                        )
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="px-3 pt-2 pb-2 d-flex floor-installation">
                <div class="pr-3 pl-1 align-self-center pointer-cursor">
                  <img
                    alt="User Icon"
                    src="assets/svg/ico-lock-warning-outline-white.svg"
                  />
                </div>
                <div>
                  {{ getBatteryError(device?.activationState) }}
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="grey-lock-align d-flex align-items-start px-2 py-1">
      <div class="pr-3">
        <img
          alt="User Icon"
          src="assets/svg/ico-locks-circle.svg"
          class="height-45 width-45 pointer-cursor"
        />
      </div>
      <div class="add-lock-heading pt-1 mt-1">
        {{ 'ADD_LOCK' | translate }}
      </div>
      <div class="add-icon pr-sm-4 pr-lg-4 pt-2 pointer-cursor">
        <img src="assets/svg/ico-add.svg" (click)="addLock()" />
      </div>
    </div>
  </ng-container>
</div>
